'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'ritetag';
var iconName = 'ritetagHashtagSet';
var width = 640;
var height = 512;
var ligatures = [];
var unicode = 'f26f';
var svgPathData = 'M140.494,98.097C167.726,98.097 189.836,120.206 189.836,147.439C189.836,174.671 167.726,196.78 140.494,196.78C113.262,196.78 91.152,174.671 91.152,147.439C91.152,120.206 113.262,98.097 140.494,98.097ZM140.494,118.432C156.503,118.432 169.501,131.429 169.501,147.439C169.501,163.448 156.503,176.446 140.494,176.446C124.485,176.446 111.487,163.448 111.487,147.439C111.487,131.429 124.485,118.432 140.494,118.432Z M247.101,2.319C264.759,5.017 279.229,10.902 286.083,24.404L495.84,234.162C511.031,258.013 507.655,275.675 495.84,290.524L290.301,496.063C280.068,505.886 270.236,510.686 260.714,511.616C246.353,513.018 232.695,505.615 219.426,493.363L14.225,288.162C6.713,283.904 2.112,272.858 0,256L0,47.594C-0.689,26.365 13.564,10.948 45.275,2.319L247.101,2.319ZM248.731,52.24L48.15,52.24L48.15,255.788L256.446,461.76L457.349,260.857L248.731,52.24Z M349.529,496.581L585.284,260.825L326.778,2.319L374.947,2.319C386.013,2.678 395.969,4.857 404.814,13.631L621.188,230.005C640.486,248.925 640.061,271.03 620.87,292.598L419.834,494.342C403.296,508.15 364.305,511.345 349.529,496.581Z';

exports.definition = {
    prefix: prefix,
    iconName: iconName,
    icon: [
        width,
        height,
        ligatures,
        unicode,
        svgPathData
    ]};

exports.ritetagHashtagSet = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = ligatures;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
